var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-order-list',{attrs:{"check":true},on:{"order-selected":_vm.handleOrder}}),_c('div',{staticClass:"container-center"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_vm._v("保存")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }